/*
  "Collection spotlight" mega menu content type: hovering (or focusing) a
  [data-spotlight-trigger] link swaps the heading/description/images shown
  in that same dropdown's [data-spotlight-panel] to that link's own
  collection - data comes from data-spotlight-* attributes rendered
  server-side in snippets/mega-menu-list.liquid, so no fetch is needed.
*/
(function () {
  const panels = document.querySelectorAll('[data-spotlight-panel]');
  if (!panels.length) return;

  panels.forEach((panel) => {
    const grid = panel.closest('.mega-menu__grid');
    if (!grid) return;

    const headingTarget = panel.querySelector('[data-spotlight-heading-target]');
    const descriptionTarget = panel.querySelector('[data-spotlight-description-target]');
    const imageTargets = panel.querySelectorAll('[data-spotlight-image-target]');
    const triggers = grid.querySelectorAll('[data-spotlight-trigger]');

    function show(trigger) {
      const heading = trigger.dataset.spotlightHeading;
      const description = trigger.dataset.spotlightDescription;
      const image = trigger.dataset.spotlightImage;

      if (headingTarget && heading) headingTarget.textContent = heading;
      if (descriptionTarget && description !== undefined) descriptionTarget.textContent = description;
      if (image) {
        imageTargets.forEach((img) => {
          img.src = image;
        });
      }
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('pointerenter', () => show(trigger));
      trigger.addEventListener('focus', () => show(trigger));
    });
  });
})();
